import React from "react";
import styles from "./Alert.module.scss";
import { AlertSize, AlertVariation, Alert as UIAlert } from "@yoti/ui-kit-components-react/alert";

export const Alert = ({ title, message }) => (
  <div className={styles.alert}>
    <UIAlert
      size={AlertSize.Large}
      type={AlertVariation.Danger}
      icon
      heading={title}
    >
      {message}
    </UIAlert>
  </div>
);
